import React from 'react';
import PrimaryButton from 'components/buttons/PrimaryButton';
import ModuleOrderModal from '../billing/ModuleOrderModal';
import { useModal } from 'components/modals/ModalContext';

interface OrderIntegrationButtonProps {
    featureKey: string;
    onOrdered?: () => void;
};

// Button which opens the module order modal to order an integration feature
const OrderIntegrationButton: React.FC<OrderIntegrationButtonProps> = ({ featureKey, onOrdered }) => {
    const { initializeModal } = useModal();

    // Open the module order modal for the integration feature
    const openOrderModal = () => {
        initializeModal(
            <ModuleOrderModal feature={featureKey} onSuccess={onOrdered} />,
            { modalSize: 'small-medium' }
        );
    };

    return (
        <PrimaryButton
            label="integrations.general.order_integration_label"
            onClick={openOrderModal}
        />
    );
};

export default OrderIntegrationButton;
